import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  hide: {
    display: "none",
  },
  skeleton: {
    borderRadius: "8px",
  },
  removeIcon: {
    position: "absolute",
    right: 0,
    fontSize: "22px",
    cursor: "pointer",
  },
  removeIconImage: {
    paddingTop: "13px",
    paddingRight: "13px",
  },
}));

export default styles;
